import { Subsidiary } from './Subsidiary'

export const HotelSelectorGroup = ({
  groupName,
  formattedSubsidiaries,
  searchParam,
  handleSelect,
  isInternalAdmin
}) => {
  if (!formattedSubsidiaries?.[groupName]) return null

  const filteredHotels = formattedSubsidiaries[groupName].filter(h => {
    if (searchParam.length === 36 && searchParam.includes('-')) {
      return h.subsidiaryId === searchParam
    }

    return (h.subsidiaryName + ' #' + h.displayId + ' ' + groupName).match(
      new RegExp(searchParam, 'i')
    )
  })
  return (
    <div key={groupName}>
      {groupName !== 'parentless' && filteredHotels && filteredHotels.length > 0 ? (
        <div className="hotel-selector__group-name">{groupName}</div>
      ) : null}
      {filteredHotels.map(hotel => (
        <Subsidiary
          key={hotel.subsidiaryId}
          hotel={hotel}
          handleSelect={handleSelect}
          isInternalAdmin={isInternalAdmin}
        />
      ))}
    </div>
  )
}
